import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=53e799de"
import script from "./GlobalFooter.vue?vue&type=script&lang=ts"
export * from "./GlobalFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports